import { apiFetch } from '../../shared/api/apiClient';

export interface ApiKeyItem {
  _id: string;
  keyPrefix: string;
  label: string;
  tenantId?: string;
  isActive: boolean;
  createdAt: string;
  expiresAt?: string;
  lastUsedAt?: string;
  createdBy?: string;
}

export interface CreateApiKeyResponse {
  success: boolean;
  _id: string;
  key: string;
  keyPrefix: string;
  label: string;
  expiresAt: string | null;
  message: string;
}

export async function fetchApiKeys(): Promise<ApiKeyItem[]> {
  const res = await apiFetch('/api/keys');
  if (!res.ok) throw new Error('Failed to fetch API keys');
  return res.data.keys;
}

export async function createApiKey(label: string, expiresAt?: string): Promise<CreateApiKeyResponse> {
  const res = await apiFetch('/api/keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, expiresAt })
  });
  if (!res.ok) throw new Error('Failed to create API key');
  return res.data;
}

export async function revokeApiKey(id: string): Promise<{ success: boolean }> {
  const res = await apiFetch(`/api/keys/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to revoke API key');
  return res.data;
}

export default { fetchApiKeys, createApiKey, revokeApiKey };
